import React, { useCallback, useMemo, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';
import { useDispatch } from 'react-redux';
import { FiltersWrapper, ButtonGroupOverride, FiltersInnerWrapper, FilterSkeleton } from './summary.style';
import filterList from './config/filter';
import useTracking from '@gameday/utils/hooks/useTracking';
import changeViewAction from '@gameday/app/lib/store/actions/views';

const Filters = ({
    summaryFilters,
    isLoading,
    handleFilterChange,
    filterKey,
    summaryFilterIndex,
    activeDetail,
    stickyEnabled,
    scrollRef
}) => {
    const Tracking = useTracking();
    const translate = useTranslate();
    const dispatch = useDispatch();
    const containerRef = useRef(null);
    const [scrolled, setScrolled] = useState(false);

    const allTranslatedFilters = useMemo(() => {
        const translatedList = {};

        for (const filter in filterList) {
            const {
                dictKey,
                name
            } = filterList[filter];
    
            translatedList[dictKey] = translate(dictKey, name);
        }

        return translatedList
    
    }, [filterList]);


    const onClickHandler = useCallback((event) => {
        
        if (stickyEnabled) {
            scrollRef.current.scrollTop = 0;
        }

        const selected = event?.selected;
        const changes = event?.changes || {};
        const text = changes?.label || '';

        const cfg = {
            componentName: ['Summary', text],
            selectedIndex: selected?.[0],
            text,
            activity: 'Tab Click'
        };

        Tracking.track.track_click(cfg);

        if (handleFilterChange) {
            handleFilterChange(selected);
            dispatch(changeViewAction({
                game_tab: 'summary',
                detail: changes?.id
            }));
        }
    }, [stickyEnabled, handleFilterChange, Tracking, dispatch, scrollRef]);

    const handlers = useMemo(() => ({ onClick: onClickHandler }), [onClickHandler]);

    const data = useMemo(() => {
        const data = [];
        Object.keys(summaryFilters).forEach(key => {
            const { dictKey, type } = summaryFilters[key];
            data[key] = {
                label: allTranslatedFilters[dictKey],
                id: type
            };
        });

        return data;
    }, [filterKey, allTranslatedFilters]);

    useEffect(() => {
        const selectedButton = document.getElementById(activeDetail);
        if (selectedButton && !scrolled) {
            containerRef.current.scrollLeft = selectedButton.offsetLeft - 25;      
            setScrolled(true);
        }
    }, [filterKey]);


    return (
        <FiltersWrapper $stickyEnabled={stickyEnabled} >
            <FiltersInnerWrapper ref={containerRef}>
                {isLoading ? <>
                    <FilterSkeleton height='30px' width='40px' />
                    <FilterSkeleton height='30px' width='70px' />
                    <FilterSkeleton height='30px' width='70px' />
                </> : <ButtonGroupOverride data={ data } selected={ summaryFilterIndex } handlers={ handlers } />
                }
            </FiltersInnerWrapper>
        </FiltersWrapper>
    );
};

Filters.propTypes = {
    isLoading: PropTypes.bool,
    summaryFilters: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    handleFilterChange: PropTypes.func,
    filterKey: PropTypes.string,
    summaryFilterIndex: PropTypes.array,
    activeDetail: PropTypes.string,
    stickyEnabled: PropTypes.bool,
    scrollRef: PropTypes.object
};

export default Filters;
